import React from 'react'
import { getFullDate } from '../../utils/DateUtil'
import { Avatar, Box, Card, Grid2 } from '@mui/material'
import { toUpper, truncate } from 'lodash'
import PropTypes from 'prop-types'
import { stringToColor } from 'utils/ColorUtil'

const GlobalMessageCard = ({
    lastMessage = {},
    setSelectedMessage = () => {},
    sx = {},
}) => {
    const isSelectedStyle = lastMessage.isSelected ? { backgroundColor: 'blueStatus.main' } : {}
    return (
        <Card sx={{ borderRadius: 0, ':hover': { cursor: 'pointer', backgroundColor: 'blueStatus.main' }, ...isSelectedStyle, ...sx } }>
            <Grid2 container size={12}>
                <Grid2 container size={'grow'} alignItems={'center'} spacing={2} onClick={() => setSelectedMessage(lastMessage)} sx={{ padding: 1 }} >
                    <Grid2 size={'auto'}><Avatar sx={{ backgroundColor: stringToColor(lastMessage.login) }}>{toUpper(lastMessage.login.slice(0, 2))}</Avatar></Grid2>
                    <Grid2 container size={'grow'} spacing={0.5}>
                        <Grid2 size={12} sx={{ fontSize: '16px' }}>{lastMessage.login} - {getFullDate(lastMessage.updateDate)}</Grid2>
                        <Grid2 size={12} sx={{ fontWeight: lastMessage.isAnswered ? 'normal' : 'bold' }}>{truncate(lastMessage.message, { length: 60, separator: ' ' })}</Grid2>
                    </Grid2>
                </Grid2>
                {!lastMessage.isAnswered && <Grid2 container size={0.7} alignItems={'center'} justifyContent={'center'}><Box sx={{ width: '10px', height: '10px', bgcolor: 'primary.main', borderRadius: 8 }}/></Grid2>}
            </Grid2>
        </Card>
    )
}

GlobalMessageCard.propTypes = {
    lastMessage: PropTypes.shape({}),
    setSelectedMessage: PropTypes.func,
    sx: PropTypes.shape({}),
}

export default GlobalMessageCard